import { HTTP } from './httpCommon';

export const httpDelete = {

  ////////////////////////////////////////////
  ///ACCOUNTS
  ////////////////////////////////////////////

  //Delete Account
  deleteAccount(account, callback) {
    HTTP.delete('Accounts/'+
        account.id 
    )
      .then(response => {
        callback(response.status)
      })
      .catch(e => {
        //this.errors.push(e)
        console.log(e);
      })

  },


  ////////////////////////////////////////////
  ///INCOMES
  ////////////////////////////////////////////

  //Delete Income
  deleteIncome(income, callback) {
    HTTP.delete('Incomes/' +
      income.id
    )
      .then(response => {
        callback(response.status)
      })
      .catch(e => {
        //this.errors.push(e)
        console.log(e);
      })

  },


  ////////////////////////////////////////////
  ///EXPENSES
  ////////////////////////////////////////////

  //Delete Expense
  deleteExpense(expense, callback) {
    HTTP.delete('Expenses/' +
      expense.id
    )
      .then(response => {
        callback(response.status)
      })
      .catch(e => {
        //this.errors.push(e)
        console.log(e);
      })

  },


  ////////////////////////////////////////////
  ///BUDGETS
  ////////////////////////////////////////////

  //Delete Budget
  deleteBudget(budget, callback) {
    HTTP.delete('Budgets/' +
      budget.id
    )
      .then(response => {
        callback(response.status)
      })
      .catch(e => {
        //this.errors.push(e)
        console.log(e);
      })

  },


}



// WEBPACK FOOTER //
// ./src/api/httpDelete.js